import { useEffect } from "react";
import { Container, ContainerProps } from "@chakra-ui/react";

interface Props extends ContainerProps {
  title: string;
}

export default function Page({ title, ...rest }: Props) {
  useEffect(() => {
    document.title = `لوحة التحكم - ${title}`;
  }, [title]);

  return <Container p="9" {...rest} />;
}
